// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-07-16T10:45:21+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  188861
//    Project:        608
//    Environment:    7352 - master
//    MD5:            9259e2e8f89cf617aec26ddc46fde9cd
//    Signature:      eyJpdiI6IlRDM2xteHByV0wwMkUxVTRyZGtPYVE9PSIsInZhbHVlIjoiOEI0UlwvVGd1aXV0NFNVVHUxU0JGTkFNY2pGaHM3WVpmRXprTExZQWZNenloMDg0Wkl3bEdDUzJMSVZkZTZXMnBFdUh6b2lRSFRsQjRiUmkrV0x4a2RoZVI2ZWhsM0s4WkxGcFY0bGsxaXk4M2Z4SHFyNlpZZHQ5QWhUc1wvZm9oS1MxejU5dXNhclplZXhhdnlKYVVHNHVxbitsQ29mcE9TZHBrVm9nM0lcL2tsV1Q0WXhzWUJjR2pNZFBRaUhUZUpiTzRhbFcyS1FJdTlPajQybU5rUUZPRUZzZHlyNmdZdlUwaCtZWFFVT1hCNnhiZytiOVhWVEY4T1JqZEtmUDZHQkczalVVYkFjOEZjWXVsVHNcL3N6TDFGSFN3R1BNMHZEYk1JWEZ6NDFRK3dHRVdYWCt4K3RZeWVhM0tUZnZSZ2dZeTlTemRaZk53N1NMQ2ZoaGgwY3AzeXVNOWhJdFVPT0NIUmQ2S0IxUGgybldJTmk2ZWpXWTU4Y2xwckxTdWllSFNyXC8wQjE5eVwvTHJzTDRtNlgzVitIUT09IiwibWFjIjoiODBjNDFhMDQ5MTYyYTBjMzllYjQ4ZmVhNWUzNTQ5MDEwNzUxZjZiMzFkYmMxYjcwNjM1ZWE5YzY3ZTkzMWIzNyJ9
if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
    constructor() {
      super();

      if(!this.hasAttribute('available')) return;

      this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
      this.onClickRefreshList = this.onClickRefreshList.bind(this);
      this.fetchAvailability(this.dataset.variantId);
    }

    fetchAvailability(variantId) {
      const variantSectionUrl = `${this.dataset.baseUrl}variants/${variantId}/?section_id=pickup-availability`;

      fetch(variantSectionUrl)
        .then(response => response.text())
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
          this.renderPreview(sectionInnerHTML);
        })
        .catch(e => {
          const button = this.querySelector('button');
          if (button) button.removeEventListener('click', this.onClickRefreshList);
          this.renderError();
        });
    }

    onClickRefreshList(evt) {
      this.fetchAvailability(this.dataset.variantId);
    }

    renderError() {
      this.innerHTML = '';
      this.appendChild(this.errorHtml);

      this.querySelector('button').addEventListener('click', this.onClickRefreshList);
    }

    renderPreview(sectionInnerHTML) {
      const drawer = document.querySelector('pickup-availability-drawer');
      if (drawer) drawer.remove();
      if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
        this.innerHTML = "";
        this.removeAttribute('available');
        return;
      }

      this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
      this.setAttribute('available', '');

      document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));

      this.querySelector('button').addEventListener('click', (evt) => {
        document.querySelector('pickup-availability-drawer').show(evt.target);
      });
    }
  });
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define('pickup-availability-drawer', class PickupAvailabilityDrawer extends HTMLElement {
    constructor() {
      super();

      this.onBodyClick = this.handleBodyClick.bind(this);

      this.querySelector('button').addEventListener('click', () => {
        this.hide();
      });

      this.addEventListener('keyup', () => {
        if(event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
    }

    handleBodyClick(evt) {
      const target = evt.target;
      if (target != this && !target.closest('pickup-availability-drawer') && target.id != 'ShowPickupAvailabilityDrawer') {
        this.hide();
      }
    }

    hide() {
      this.removeAttribute('open');
      document.body.removeEventListener('click', this.onBodyClick);
      document.body.classList.remove('overflow-hidden');
      removeTrapFocus(this.focusElement);
    }

    show(focusElement) {
      this.focusElement = focusElement;
      this.setAttribute('open', '');
      document.body.addEventListener('click', this.onBodyClick);
      document.body.classList.add('overflow-hidden');
      trapFocus(this);
    }
  });
}
